import loadTypes from 'utils/loadTypes'
import groupBy from 'lodash/groupBy'

export const INSIGHT_LANDINGS_WORST = loadTypes('INSIGHT_LANDINGS_WORST')
export const INSIGHT_LANDINGS_BEST = loadTypes('INSIGHT_LANDINGS_BEST')
export const INSIGHT_LANDINGS_VALUABLE = loadTypes('INSIGHT_LANDINGS_VALUABLE')
export const INSIGHT_LANDINGS_FREQUENT = loadTypes('INSIGHT_LANDINGS_FREQUENT')
export const INSIGHT_LANDINGS_TOTAL_TRAFFIC = loadTypes('INSIGHT_LANDINGS_TOTAL_TRAFFIC')
export const INSIGHT_FILTER = 'INSIGHT_FILTER'

function set(obj, path, value) {
  const pathItem = path.shift()
  if (path.length) {
    obj[pathItem] = obj[pathItem] || {}
    set(obj[pathItem], path, value)
  } else {
    obj[pathItem] = value || {}
  }
}

function processLandings(request, response) {
  let grouppedByName = groupBy(response, 'dimensions.landingPage')

  return Object.keys(grouppedByName).reduce((acc, name) => {
    grouppedByName[name].forEach(landing => {
      set(acc,
        [name],
        {
          traffic: landing['session:count'],
          total: landing['order:total'],
          cr: landing['session:conversionRate'],
          br: landing['session:bounceRate'],
          vpv: landing['session:valuePerVisit']
        }
      )
    })

    return acc
  }, {})
}

const initialState = {
  totalTraffic: null,
  worstData: null,
  bestData: null,
  valuableData: null,
  frequentData: null,
  selectedChannel: {
    channelId: null,
    channelGroupId: null
  },
  isWorstDataFetching: false,
  isBestDataFetching: false,
  isValuableDataFetching: false,
  isFrequentDataFetching: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case INSIGHT_LANDINGS_TOTAL_TRAFFIC.REQUEST:
      return {
        ...state,
        isWorstDataFetching: true,
        isBestDataFetching: true,
        isValuableDataFetching: true,
        isFrequentDataFetching: true
      }
    case INSIGHT_LANDINGS_TOTAL_TRAFFIC.SUCCESS:
      const [{'session:count': totalTraffic}] = action.response

      return {
        ...state,
        totalTraffic
      }
    case INSIGHT_LANDINGS_TOTAL_TRAFFIC.FAILURE:
      return {
        ...state,
        isWorstDataFetching: false,
        isBestDataFetching: false,
        isValuableDataFetching: false,
        isFrequentDataFetching: false
      }
    case INSIGHT_LANDINGS_WORST.SUCCESS:
      return {
        ...state,
        isWorstDataFetching: false,
        worstData: processLandings(action.request, action.response)
      }
    case INSIGHT_LANDINGS_WORST.FAILURE:
      return {
        ...state,
        isWorstDataFetching: false
      }
    case INSIGHT_LANDINGS_BEST.SUCCESS:
      return {
        ...state,
        isBestDataFetching: false,
        bestData: processLandings(action.request, action.response)
      }
    case INSIGHT_LANDINGS_BEST.FAILURE:
      return {
        ...state,
        isBestDataFetching: false
      }
    case INSIGHT_LANDINGS_VALUABLE.SUCCESS:
      return {
        ...state,
        isValuableDataFetching: false,
        valuableData: processLandings(action.request, action.response)
      }
    case INSIGHT_LANDINGS_VALUABLE.FAILURE:
      return {
        ...state,
        isValuableDataFetching: false
      }
    case INSIGHT_LANDINGS_FREQUENT.SUCCESS:
      return {
        ...state,
        isFrequentDataFetching: false,
        frequentData: processLandings(action.request, action.response)
      }
    case INSIGHT_LANDINGS_FREQUENT.FAILURE:
      return {
        ...state,
        isFrequentDataFetching: false
      }
    case INSIGHT_FILTER:
      return {
        ...state,
        selectedChannel: {
          channelId: action.channelId,
          channelGroupId: action.channelGroupId
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/insights/landings.js